import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, debounce, Options} from "../utils/decorators";
import * as Cookies from 'js-cookie';

const IE11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;

@Options({
    template: false,
    ui: {

    },
})
export default class GlobalAlert extends Marionette.View<Backbone.Model>{
    element: HTMLElement;
    alerts: NodeListOf<HTMLElement>;
    body: HTMLElement;
    closeButton: HTMLElement;
    pageID: string;
    pageAlertCookie: Array<String>;
    hashes: Array<String>

    constructor(options?:object) {
        super(options);

        this.element = this.$el.get(0);
        this.closeButton = this.element.querySelector('.global-alert__close');
        this.body = document.querySelector('body');
        this.alerts = this.element.querySelectorAll('.global-alert');

        let pageAlertCookieString = Cookies.get('page_alerts');
        this.pageAlertCookie = [];
        this.hashes = [];
        if(pageAlertCookieString) {
            this.pageAlertCookie = JSON.parse(pageAlertCookieString);
        } else {
            Cookies.set('page_alerts', []);
        }


        let visibleElements = false;

        Array.prototype.forEach.call(this.alerts, function (alertElement) {
           let hash = alertElement.getAttribute('data-alert-hash');

           alertElement.classList.remove('visible');

           if (Array.isArray(this.pageAlertCookie)) {
               if (this.pageAlertCookie.indexOf(hash) === -1) {
                    alertElement.classList.add('visible'); // add visible to the individual elements
                    this.hashes.push(hash.trim()); // push to the hashes array so we can add it to the cookie
                    visibleElements = true; // set the visible elements flag to true so we know that there are elements to display
               }
           }
        }.bind(this));

        if(visibleElements) {
            this.element.classList.add('visible');
            this.body.classList.add('alerts-visible');
        } else {
            this.element.classList.remove('visible');
        }
    }

    onRender() {
        this.closeButton.addEventListener('click', () => {
            let hashToAdd = this.pageAlertCookie.concat(this.hashes);
            var in6hours = (1/24) * 7;
            Cookies.set('page_alerts', hashToAdd, {expires: in6hours});
            this.element.classList.remove('visible');
            this.body.classList.remove('alerts-visible');
        });
    }
}



// WEBPACK FOOTER //
// ./@modules/views/global-alert-view.ts